import { dateLocale } from "../i18n";

export const formatTime = (time: string): string => {
  return time.split(":").slice(0, 2).join(":");
};

export const formatDate = (date: string): string => {
  const parts = date.split("-").map((part) => Number(part));
  if (parts.length !== 3 || parts.some((part) => Number.isNaN(part))) {
    return date;
  }
  const [year, month, day] = parts;
  return new Date(year, month - 1, day).toLocaleDateString(dateLocale(), {
    weekday: "short",
    day: "numeric",
    month: "short",
  });
};

export const todayIso = (): string => {
  const today = new Date();
  const month = String(today.getMonth() + 1).padStart(2, "0");
  const day = String(today.getDate()).padStart(2, "0");
  return `${today.getFullYear()}-${month}-${day}`;
};

export const addDaysIso = (days: number): string => {
  const date = new Date();
  date.setDate(date.getDate() + days);
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${date.getFullYear()}-${month}-${day}`;
};
